// ============================================================
// Chess Arena — Splash Screen
// Animated loading screen with title and fake progress bar
// ============================================================

import type { Screen } from '../screenManager';
import type { PlayerStateData } from '../../core/types';

export class SplashScreen implements Screen {
  readonly name = 'splash';
  private container!: HTMLElement;
  private loadTimer: number | null = null;
  private onComplete: ((route: 'mainMenu' | 'tutorial') => void) | null = null;
  private playerState: PlayerStateData | null = null;

  /** Set the callback to invoke after loading completes. */
  setOnComplete(cb: (route: 'mainMenu' | 'tutorial') => void): void {
    this.onComplete = cb;
  }

  /** Set the player state to determine routing after splash. */
  setPlayerState(state: PlayerStateData): void {
    this.playerState = state;
  }

  init(container: HTMLElement): void {
    this.container = container;
    container.classList.add('splash-screen');

    container.innerHTML = `
      <div class="splash-bg"></div>
      <div class="splash-content">
        <div class="splash-loader">
          <div class="splash-loader-fill"></div>
        </div>
      </div>
    `;
  }

  show(_data?: Record<string, unknown>): void {
    // Reset the loading bar animation
    const fill = this.container.querySelector('.splash-loader-fill') as HTMLElement;
    if (fill) {
      fill.style.animation = 'none';
      void fill.offsetHeight;
      fill.style.animation = '';
    }

    // After 2.2s (loading bar animation + buffer), route to next screen
    this.loadTimer = window.setTimeout(() => {
      const route = this.playerState?.onboardingComplete ? 'mainMenu' : 'tutorial';
      this.onComplete?.(route);
    }, 2200);
  }

  hide(): void {
    if (this.loadTimer !== null) {
      clearTimeout(this.loadTimer);
      this.loadTimer = null;
    }
  }

  update(): void {
    // No periodic updates needed
  }

  destroy(): void {
    this.hide();
    this.container.innerHTML = '';
  }
}
